export default "__VITE_ASSET__DlfGxvta__"